import type {
  ComponentProps,
  ReactNode,
} from "react"

import { OnboardingPageHeader } from "./OnboardingPageHeader"
import { Page } from "./Page"

interface Props extends ComponentProps<typeof OnboardingPageHeader> {
  title?: ComponentProps<typeof OnboardingPageHeader>["children"];
  children?: ReactNode;
}

export function OnboardingPageTemplate(props: Props) {
  const {
    title,
    children,
    ...headerProps
  } = props

  return (
    <>
      <OnboardingPageHeader {...headerProps}>
        {title}
      </OnboardingPageHeader>
      <Page>
        {children}
      </Page>
    </>
  )
}
